import { apiCall, apiClient } from '../client/apiClient';

export const login = async (reqBody: Record<string, unknown>) => {
  const { data } = await apiClient.POST('/authentication/login', { body: reqBody as any });
  return data;
};

export const logout = async () => {
  const { data } = await apiClient.POST('/authentication/logout');
  return data;
};

export const getUserData = async () => {
  const data = await apiCall(apiClient.GET('/authentication/user'));
  return data.user;
};
